import type { HookRef } from "app/services/ModalService";
import { EHooksVersions } from "app/services/SwHook";

import type { AdIntelligenceController } from "../shared/types/types";

// Mirrors consul web/<env>/Applications/hooks.similarweb/HooksConfiguration: every key exists in one
// version only, and opening it with another one silently falls back to the default hook.
export const AD_INTELLIGENCE_HOOKS = {
    advertiser: {
        touch: { key: "AdIntelligence", version: EHooksVersions.V5 },
        noTouch: { key: "advertiserActivityNoTouch", version: EHooksVersions.V6 },
        upgradeToTouch: { key: "AdvertiserActivityUpgradeToTouch", version: EHooksVersions.V5 },
    },
    publisher: {
        touch: { key: "PublisherAnalysis", version: EHooksVersions.V5 },
        noTouch: { key: "publisherAnalysisNoTouch", version: EHooksVersions.V6 },
        upgradeToTouch: { key: "PublisherAnalysisUpgradeToTouch", version: EHooksVersions.V5 },
    },
} as const satisfies Record<AdIntelligenceController, Record<"touch" | "noTouch" | "upgradeToTouch", HookRef>>;
